module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAk0AAAAGCAYAAADe+qreAAAA1klEQVRoQ+3asQ3CQAxG4ecGZoBNYA9GQHQMAx0zMAejsAOVkQOKBEqU0B7vyosVyd81v2QHIyczN8AVWI/VeK+AAgoooIACCjQkcAd2EXEb6imGLjNzD5yBZUMQtqKAAgoooIACCkwJPIBjRFy+Cz9CU2YugBNwmPqj3xVQQAEFFFBAgYYFKjRVeKoQ1Z0+NGXm6j2O2zYMYGsKKKCAAgoooMBcgRrT1biuxnav0OT+0lw76xRQQAEFFFDgzwT6Padwf+nPnt52FVBAAQUUUOBXgW7P6QkrKyNqzbst9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bottom_border.png
// module id = jdoW
// module chunks = 1